<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="자재명세서 목록">
                <template #add-button>
                    <mes-bom-create @input="search">
                        <template #activator="{ attrs, on }">
                            <v-btn text icon tile color="primary" class="my-n1" v-bind="attrs" v-on="on">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                    </mes-bom-create>
                </template>
            </list-heading>

            <v-card outlined class="mt-4" style="overflow: hidden">
                <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer :items-per-page="-1" @click:row="openItem">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                    <template #[`item.actions`]="{ item }">
                        <v-btn small text icon tile @click="remove(item)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>

            <mes-bom-update v-bind="props__update" @input="updateItem" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, initDataTableHeaders } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import MesBomCreate from "@/components/console/mes/boms/mes-bom-create.vue";
import MesBomUpdate from "@/components/console/mes/boms/mes-bom-update.vue";

const headers = initDataTableHeaders([
    { text: "ECO No", value: "ECO_NO", width: 160, align: "center" },
    { text: "형태", value: "ECO_TYPE_NAME", width: +80, align: "center" },
    { text: "구분", value: "ECO_FLAG_NAME", width: 100, align: "center" },
    { text: "시방일자", value: "ECO_DATE", width: 130, align: "center" },
    { text: "적용일자", value: "DATE_FR", width: 130, align: "center" },
    { text: "종료일자", value: "DATE_TO", width: 130, align: "center" },
    { text: "품번", value: "MODEL_CODE" },
    { text: "품명", value: "MODEL_NAME" },
    { text: "Rev.", value: "REVISION", width: +80, align: "center" },
    { text: "Rank", value: "RANK", width: 100, align: "center" },
    // { text: "", value: "actions", width: +60, align: "center" },
]);

export default {
    components: {
        ListHeading,
        MesBomCreate,
        MesBomUpdate,
    },
    data: () => ({
        boms: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        headers,
        attrs_input,
    }),
    computed: {
        items() {
            return this.boms.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.ecoNo;
            delete query.modelCode;
            delete query.revision;
            delete query.rank;

            return { ...query };
        },
        props__update() {
            let { ecoNo, modelCode, revision, rank } = this.$route.query;
            return { ecoNo, modelCode, revision, rank };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, boms } = await api.console.mes.boms.gets({
                    headers: { skip, limit },
                    params,
                });

                this.boms = boms;
                this.summary = summary;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async remove(item) {
            if (!confirm("해당 항목을 삭제하시겠습니까?")) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.console.mes.boms.delete(item);
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.boms.findIndex(({ ecoNo, modelCode, revision, rank }) => ecoNo == item.ecoNo && modelCode == item.modelCode && revision == item.revision && rank == item.rank);
            if (0 <= index) this.boms.splice(index, 1, item);
            else {
                this.summary.totalCount += 1;
                this.boms = [item, ...this.boms];
            }
            this.search();
        },

        openItem(item) {
            this.$router.replace({
                query: {
                    ecoNo: item?.ECO_NO,
                    modelCode: item?.MODEL_CODE,
                    revision: item?.REVISION,
                    rank: item?.RANK,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }

    .v-data-table tr td {
        cursor: pointer !important;
    }
}
</style>
